(() => {
  const HLIO_BUNDLES = [
    { label: "6", handle: "ib6", id: "49331587580163", qty: 6 },
    { label: "9", handle: "ib9", id: "49331590136067", qty: 9 },
    { label: "12", handle: "ib12", id: "49331591774467", qty: 12 },
  ];

  const root = document.getElementById("hlioRoot");
  if (!root) return;

  const bundleDataMap = new Map();

  for (const bundle of HLIO_BUNDLES) {
    const bundleEl = document.getElementById(`hlio-bundle-json-${bundle.handle}`);
    if (!bundleEl) continue;

    try {
      const product = JSON.parse(bundleEl.textContent);
      const variant =
        (product?.variants || []).find((v) => String(v.id) === String(bundle.id)) ||
        product?.variants?.[0];

      if (variant) {
        bundleDataMap.set(String(bundle.id), {
          variantId: Number(variant.id),
          price: Number(variant.price) || 0,
          compare_at_price: Number(variant.compare_at_price || 0),
          available: variant.available !== false,
        });
      }
    } catch {
      // ignore invalid JSON
    }
  }

  const pillsContainer = document.getElementById("hlioPills");
  const perUnitEl = document.getElementById("hlioPerUnit");
  const totalEl = document.getElementById("hlioTotalPrice");
  const compareEl = document.getElementById("hlioTotalCompareAt");
  const addBtn = document.getElementById("hlioAddToCart");

  if (!pillsContainer || !perUnitEl || !totalEl || !compareEl || !addBtn) return;

  let selectedId = String(HLIO_BUNDLES[0].id);

  pillsContainer.innerHTML = HLIO_BUNDLES.map((bundle) => `
    <button
      type="button"
      class="hlio-pill${String(bundle.id) === selectedId ? " is-active" : ""}"
      data-id="${bundle.id}"
      aria-pressed="${String(bundle.id) === selectedId ? "true" : "false"}"
    >${bundle.label}</button>
  `).join("");

  pillsContainer.addEventListener("click", (e) => {
    const pill = e.target.closest(".hlio-pill");
    if (!pill) return;

    selectedId = pill.dataset.id;

    pillsContainer.querySelectorAll(".hlio-pill").forEach((p) => {
      const active = p.dataset.id === selectedId;
      p.classList.toggle("is-active", active);
      p.setAttribute("aria-pressed", active ? "true" : "false");
    });

    update();
  });

  const money = (cents) => "₪" + Math.round(cents / 100);
  const money2 = (shekels) => "₪" + Number(shekels).toFixed(2);

  const update = () => {
    const bundleMeta = HLIO_BUNDLES.find((item) => String(item.id) === selectedId);
    const bundleData = bundleDataMap.get(selectedId);

    if (!bundleMeta || !bundleData) {
      perUnitEl.textContent = "";
      totalEl.textContent = "";
      compareEl.style.display = "none";
      return;
    }

    const iceCents = bundleData.price;
    const iceCompareCents = bundleData.compare_at_price;
    const qty = bundleMeta.qty || 1;

    const perUnit = (iceCents / 100) / qty;
    perUnitEl.textContent = `(${money2(perUnit)} ליח׳)`;

    totalEl.textContent = money(iceCents);

    if (iceCompareCents > iceCents) {
      compareEl.style.display = "inline-block";
      compareEl.textContent = money(iceCompareCents);
    } else {
      compareEl.style.display = "none";
      compareEl.textContent = "";
    }

    if (bundleData.available) {
      addBtn.disabled = false;
      addBtn.textContent = "הוספה לסל";
    } else {
      addBtn.disabled = true;
      addBtn.textContent = "אזל המלאי";
    }
  };

  update();

  addBtn.addEventListener("click", async () => {
    const bundleData = bundleDataMap.get(selectedId);
    if (!bundleData) return;

    addBtn.disabled = true;
    const originalLabel = addBtn.textContent;
    addBtn.textContent = "מוסיף...";

    const items = [{ id: bundleData.variantId, quantity: 1 }];

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items }),
      });

      if (!res.ok) throw new Error("cart/add failed");

      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:updated"));
      document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
      document.dispatchEvent(new CustomEvent("product:added"));

      addBtn.textContent = originalLabel;
    } catch (e) {
      console.error(e);
      addBtn.textContent = originalLabel;
    } finally {
      addBtn.disabled = false;
    }
  });
})();